exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cpd-list-card[data-v-955df00c]  .v-toolbar__title{font-size:18px;font-weight:500}.cpd-table[data-v-955df00c]  .v-data-table-header th{font-weight:600}.cpd-table[data-v-955df00c]  tbody td{font-size:12px;line-height:1.35}", ""]);

// exports
